// extracted by mini-css-extract-plugin
export default {"processWordTextAreaAuto":"articleWordChecker_processWordTextAreaAuto__6lCSS","inputBox":"articleWordChecker_inputBox__AKJzs"};